export default __webpack_public_path__ + "static/media/greyFilledEllipsis.ececa80d.svg";